import * as React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { RemoveIcon } from 'elc-icons';
import { ResponsiveModal } from 'elc-responsive-modal';
import { classes } from '../../internal/utils/Classes';
import { ContentSpacing } from 'elc-base-theme';

export interface IProductInfoPopup {
    onCloseButtonClick(): void;
    children: JSX.Element;
    title: string;
    isProductInfoPopupOpen: boolean;
}

const ProductInfoModal = styled(ResponsiveModal)`
    padding: ${ContentSpacing.space10};
`;

const ProductInfoModalCloseButton = styled.button`
    border: none;
    outline: none;
    float: right;
    margin: ${ContentSpacing.space10};
    [dir='rtl'] & {
        float: left;
    }
`;

const PopupWrapper = styled.div`
    margin-top: ${ContentSpacing.space24};
    display: inline-block;
    width: 100%;
`;

export const ProductInfoPopup = observer((props: IProductInfoPopup) => {
    const productInfoPopupWrapperClassNames = classes('product-info-popup-wrapper');
    const productInfoModalClassNames = classes('product-info-modal');
    const productInfoModalCloseButtonClassNames = classes('product-info-modal-close-button');
    const productInfoModalCloseIconClassNames = classes('product-info-modal-close-icon');
    const { title, isProductInfoPopupOpen, onCloseButtonClick, children } = props;

    return (
        <PopupWrapper className={productInfoPopupWrapperClassNames}>
            <ProductInfoModal
                isOpen={isProductInfoPopupOpen}
                title={title}
                deactivateModal={onCloseButtonClick}
                onMaskClick={onCloseButtonClick}
                className={productInfoModalClassNames}
            >
                <ProductInfoModalCloseButton
                    className={productInfoModalCloseButtonClassNames}
                    onClick={onCloseButtonClick}
                >
                    <RemoveIcon className={productInfoModalCloseIconClassNames} />
                </ProductInfoModalCloseButton>
                {children}
            </ProductInfoModal>
        </PopupWrapper>
    );
});
